import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-input-checkbox',
  templateUrl: './input-checkbox.component.html',
  styleUrls: ['./input-checkbox.component.scss']
})
export class InputCheckboxComponent implements OnInit {
  @Input() labelName: string;
  @Input() inputFormControl: FormControl;
  @Input() showLabel = true;
  @Output() onCheckedUnCheckedEvent = new EventEmitter();
  public id: string;
  constructor() { }

  ngOnInit(): void {
    if (this.labelName) {
      this.id = this.labelName.split(' ').join('_').toString().concat('_' + Math.random());
    }
  }

    public onCheckBoxSelect(checkUncheckStatus): void {
      this.onCheckedUnCheckedEvent.emit(checkUncheckStatus.target.checked);
    }
}
